describe("digitalData", () => {
    it("configuracion exportada por defecto", () => {
      const digitalData = require("@/digitalData");
      expect(digitalData).toBeDefined();
    });
});